import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  description: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    color: '#2C2D3E',
    marginTop: '-10px',
    marginBottom: '20px',
  },
  iconCircle: {
    display: 'inline-block',
    width: '28px',
    height: '28px',
    marginLeft: '10px',
    verticalAlign: 'middle',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#CACAFC5E',
    },
  },
  defaultRoleIcon: {
    margin: '5px',
  },
  listHeader: {
    height: '40px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
  },
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
  },
  searchBar: {
    position: 'absolute',
    right: '0px',
  },
}));
